<!-- Village Virtual Office -->
<section class="virtual_office_sec" *ngIf="governmentOfficesSettings">
  <div class="virtual_right"></div>
  <div class="virtual_left"></div>
  <div class="wrapper">
    <div class="custom_heading">
      <h2 class="title">
        <span *ngIf="lang==='en'"> Government Offices </span>
        <span *ngIf="lang==='te'"> ప్రభుత్వ కార్యాలయాలు </span>
      </h2>
    </div>
    <div class="row-wrap virtual_office_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
      fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="40px">

      <div class="virtual_office_column" fxLayout="column" fxFlex.xl="28" fxFlex.lg="28" fxFlex.md="28" fxFlex.sm="28"
        fxFlex.xs="100" fxFlexFill *ngFor="let singleSection of sections">
        <!-- document_box -->
        <div class="virtual_box">
          <div class="virtual_img">
            <img [src]="governmentOfficesSettings[singleSection.id].image.url" alt="important_document_1">
          </div>
          <div class="virtual_content">
            <h3 *ngIf="lang==='en'"> {{governmentOfficesSettings[singleSection.id].en_title}} </h3>
            <h3 *ngIf="lang==='te'"> {{governmentOfficesSettings[singleSection.id].te_title}} </h3>
            <button class="btn btn-sm read-btn" mat-button [routerLink]="['/government_offices_settings/anganwadi_centers']">Read More</button>
          </div>
        </div>
      </div>



    </div>
  </div>
  <section class="virtual_office_bottom">
    <img src="../../../../../assets/images/village_virtual_office_bull_cart.png"
      alt="village_virtual_office_bull_cart">
  </section>
</section>
